import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { map, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  toaster = inject(ToastrService);
  signup_personal_info_form = signal<any>({});
  readonly currentUser = signal<any | null>(this.getStoredUser());

  readonly currentUserId = computed(() => this.currentUser()?.user?.id);

  readonly currentUserName = computed(() => this.currentUser()?.user?.username);

  readonly signupPersonalInfo = signal<Record<string, any>>({});

  private getStoredUser() {
    const user = localStorage.getItem(environment.currentUserKey);
    return user ? JSON.parse(user) : null;
  }

  private storeSession(data: any) {
  let updated_data={}
    if(data.user){
      updated_data = {...data,admin:data.user}
    }
    else if(data?.admin){
      updated_data = data
    }
    localStorage.setItem('ShuwierToken', data.token);
    localStorage.setItem(environment.currentUserKey, JSON.stringify(updated_data));

    this.currentUser.set(updated_data);
  }

  private createFormData(data: Record<string, any>): FormData {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        formData.append(key, value as string | Blob);
      }
    });

    return formData;
  }
  saveSignupInfo(form: any) {
    this.signup_personal_info_form.set(form);
  }
  login(form: { email: string; password: string }) {
    return this.http.post<any>(`${environment.endpoint}/auth/login`, form).pipe(
      tap((res) => {
        if (res?.data?.token) {
          this.storeSession(res.data);
        }
      }),
    );
  }
  changePassword(form: {
    current_password: string;
    new_password: string;
    new_password_confirmation: string;
  }) {
    return this.http.post<any>(`${environment.endpoint}/auth/change-password`, form).pipe(
      tap((res) => {
        console.log(res);
      }),
    );
  }
  changeFirstPassword(form: {
    email: string;
    password: string;
    password_confirmation: string;
    token: string;
  }) {
    return this.http.post<any>(`${environment.endpoint}/auth/first-password`, form).pipe(
      tap((res) => {
        this.toaster.success(res.message);
        this.logout();
      }),
    );
  }
  forgetPassword(form: { email: string }) {
    return this.http.post<any>(`${environment.endpoint}/auth/forget-password`, form).pipe(
      tap((res) => {
        this.logout();
      }),
    );
  }
  resendCode(form: any) {
    const formData = new FormData();
    formData.append('email', form.email);

    return this.http.post(`${environment.endpoint}/auth/resend-code`, formData).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }
  // auth/change-password

  verifyEmail(form: any, endpoint = 'verify-email') {
    return this.http
      .post<any>(`${environment.endpoint}/auth/${endpoint}`, this.createFormData(form))
      .pipe(
        tap((res) => {
          if (res?.data?.token) {
            this.storeSession(res.data);
          }
        }),
      );
  }

  refreshToken() {
    return this.http.post<any>(`${environment.baseUrl}/auth/refresh`, {});
  }

  refreshAndUpdateSession() {
    return this.refreshToken().pipe(
      tap((res) => {
        if (res?.data?.token) {
          const updated = {
            ...this.currentUser(),
            ...res.data,
          };
          console.log(updated);

          this.storeSession(res?.data);
        }
      }),
    );
  }

  patchStoredUser(patch: Record<string, unknown>) {
    const current = this.currentUser();

    if (!current) return;

    const updated = {
      ...current,
      user: {
        ...current.user,
        ...patch,
      },
    };

    this.storeSession(updated);
  }
  resetPassword(form: { email: string; password: string; token: string }) {
    return this.http.post<any>(`${environment.endpoint}/auth/reset-password`, form).pipe(
      tap((res) => {
        if (res?.data?.token) {
          this.storeSession(res.data);
        }
      }),
    );
  }
  logoutLocal() {
    this.clearSession();
    this.router.navigate(['/login']);
  }
  logout() {
    return this.http.post<any>(`${environment.baseUrl}/auth/logout`, {}).pipe(
      tap(() => {
        this.logoutLocal();
        this.toaster.success('Logged out successfully');
      }),
    );
  }
  clearSession() {
    localStorage.clear();
    this.currentUser.set(null);
  }
}
